import classNames from "classnames";
import * as React from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import Data from "../../../../services/Data";
import Nameof from "../../../../services/NameOf";
import { IAppContainerState } from "../../../AppContainer";
import { sharedStylesOld } from "../../../Shared/Styles/SharedStyles";
import { InnerProgressBar } from "./InnerProgressBar/InnerProgressBar";
import {
    MarkLevelProgressBarMounted,
    MarkLevelProgressBarUnmounted,
} from "./LevelProgressBarLifecycle";
import * as styles from "./LevelProgressBar.css";
import { LevelProgressBarProps } from "./LevelProgressBarProps";
import { LevelProgressBarState } from "./LevelProgressBarState";

export class LevelProgressBar extends React.PureComponent<
    LevelProgressBarProps,
    LevelProgressBarState
> {
    constructor(props: LevelProgressBarProps) {
        super(props);
    }

    state = {
        progress: 0,
        isAnimated: false,
    };

    componentDidMount() {
        MarkLevelProgressBarMounted();
        State.ShareClass(ESharedComponent.LevelProgressBar, this);

        if (this.props.GetProgress) {
            Data.Load.Component({
                component: this,
                load: this.props.GetProgress,
                stateTarget: Nameof<LevelProgressBarState>("progress"),
            });
        }
    }

    componentDidUpdate() {
        if (this.props.progress) {
            this.setState({ progress: this.props.progress });
        }

        State.ShareClass(ESharedComponent.LevelProgressBar, this);
    }

    componentWillUnmount() {
        Data.Unload(this);
        MarkLevelProgressBarUnmounted();
    }

    render() {
        const appContainer = State.ReadClass<IAppContainerState>(
            ESharedComponent.AppContainer
        );

        if (!appContainer) {
            return <span />;
        }

        const tooltipText = `${this.state.progress}% towards Level ${
            appContainer.state.level + 1
        }`;

        return (
            <div
                data-tip={tooltipText}
                data-offset="{'top': 10}"
                id="progressBarBackground_calcTarget"
                className={classNames([styles.outerProgressBar], {
                    [sharedStylesOld.flashOpacity]: !IsMobileDevice(),
                })}
            >
                <InnerProgressBar
                    progress={this.state.progress}
                    isAnimated={this.state.isAnimated}
                />
            </div>
        );
    }
}

const ProgressBar = () => (
    <LevelProgressBar GetProgress={GetLevelProgressAsync} />
);

export default ProgressBar;

export async function GetLevelProgressAsync() {
    const kipsToLevelUp = await Data.GetKipsToLevelUp();
    const currentLevel = await MotwLogicServer.GetPlayerLevelCurrent();

    const progress =
        1 -
        kipsToLevelUp /
            (Math.pow((currentLevel + 1) / 0.1, 2) -
                Math.pow(currentLevel / 0.1, 2));

    const progressPercent = Math.floor(progress * 100);
    return progressPercent;
}
